import React, {FC, useEffect} from 'react';

import {sendDesktopAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {LoadingOverlay} from 'components/loadingOverlay/loadingOverlay';
import {GENERAL_EXPERIMENT_INDICATION} from 'constants/analytics/events/general';
import {CurrentAddressType} from 'desktop/types/addressType';
import {useIsOneStepAvailable} from 'hooks/useIsOneStepAvailable/useIsOneStepAvailable';
import {flags} from 'libs/rollout';

import {DeliveryStepConnected} from '../deliveryStep/deliveryStep';
import {DeliveryStepEditAddressConnected} from '../deliveryStepEditAddress/deliveryStepEditAddress';
import {OneStep} from '../oneStep/oneStep';
import {PaymentStepConnected} from '../paymentStep/paymentStep';

import s from './steps.scss';

export type PropsType = {
    addressType: CurrentAddressType;
    pageType: Maybe<'edit' | 'new'>;
    isLoading?: boolean;
};

const EDIT_PAGES = ['edit', 'new'];

/**
 * Steps for checkout
 *
 * @constructor
 */
export const Steps: FC<PropsType> = ({addressType, isLoading, pageType}) => {
    const {isOneStepAvailable} = useIsOneStepAvailable();
    const isExp = flags.dCheckout1step.isEnabled();

    useEffect(() => {
        sendDesktopAnalyticsPerSession({
            event: GENERAL_EXPERIMENT_INDICATION,
            isInteraction: false,
            label: {
                expName: 'dCheckout1step',
                label: String(isExp && isOneStepAvailable),
            },
        });
    }, [isOneStepAvailable, isExp]);

    return (
        <section className={s.wrapper}>
            {isLoading && <LoadingOverlay aria-label="Loading checkout" />}

            {pageType && EDIT_PAGES.includes(pageType) ? (
                <DeliveryStepEditAddressConnected addressType={addressType} pageType={pageType} />
            ) : (
                <>
                    {isOneStepAvailable ? (
                        <OneStep />
                    ) : (
                        <>
                            <DeliveryStepConnected />
                            <PaymentStepConnected />
                        </>
                    )}
                </>
            )}
        </section>
    );
};

Steps.displayName = 'Steps';
